module.exports = __webpack_public_path__ + "img/edit-dark.d505cd5a.svg";